import React from "react";
import {Box, Button, Typography,} from "@mui/material";
import {useTranslation} from "react-i18next";
import CustomBreadcrumbs from "@/components/breadcrumbs/CustomBreadcrumbs";
import SnackbarUtil from "@/utils/SnackbarUtil";
import {ReactComponent as NoSubscription} from "@/assets/icons/Nosubscription.svg";

type CommonProp = {
  label: string,
  tips1: string,
  tips2: string,
  tips3: string,
}


const CommonWithoutSubscription: React.FC<CommonProp> = (props) => {
  const {t} = useTranslation();

  return (
    <>
      <CustomBreadcrumbs record={[{label: props.label}]}/>
      <Box
        sx={{
          width: "100%",
          minHeight: "calc(100vh - 70px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Box sx={{position: "relative", width: "120px", height: "150px", mb: 5}}>
          <Box
            sx={{
              position: "absolute",
              top: "8px",
              left: "10px",
              width: "96px",
              height: "130px",
              backgroundColor: "#F0F0F0",
              borderRadius: "10px",
              border: "2px solid #E0E0E0",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoSubscription/>
          </Box>
        </Box>

        <Typography
          variant="h5"
          sx={{
            color: "#333333",
            fontWeight: 700,
            fontSize: "22px",
            lineHeight: "30px",
            mb: 2,
            textAlign: "center",
          }}
        >
          {props.tips1}
        </Typography>

        <Typography
          sx={{
            color: "#888888",
            fontSize: "14px",
            lineHeight: "26px",
            mb: 4.5,
            maxWidth: "420px",
            textAlign: "center",
          }}
        >
          {props.tips2}
          <br/>
          {props.tips3}
        </Typography>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#3498DB",
            color: "#FFFFFF",
            fontSize: "15px",
            fontWeight: 600,
            py: 1.5,
            px: 6,
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {backgroundColor: "#2980B9"},
          }}
          onClick={() => {
            SnackbarUtil.warning(t("common.Subscribe in App Tips"), {
              anchorOrigin: {vertical: 'top', horizontal: 'center'}
            });
            return;
          }}
        >
          {t("Dashboard.Subscribe in App")}
        </Button>
      </Box>
    </>
  )
};

export default CommonWithoutSubscription;
